/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';

import { addMonths, format } from 'date-fns';
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import {
  MenuComponent,
} from '../../../_metronic/assets/ts/components';

import EditDocument from '../Profile/components/EditDocument';
import SelectPayment from './components/SelectPayment';

import {
  calculateMinutes,
  formatLongDate,
  formatLongDateTime,
} from '../../services/dates';

import {
  formatMoney,
} from '../../services/intFormat';

import {
  getMeInfo,
  getSessionIdFromToken,
} from '../../services/auth';

import {
  createSchedule,
} from '../../services/schedules';

import {
  createCreditPurchase,
} from '../../services/creditPurchases';

import { payOnlineInvoice } from 'app/services/invoices';
import {
  createSignature,
  updateSignature,
} from 'app/services/signatures';

import {
  trackAddPaymentInfo,
  trackAddToCart,
  trackBeginCheckout,
  trackPurchase,
  buildEcommerceParams,
} from '../../services/analytics';

const PaymentPage = ({isOpen, onClosed, attributes}) => {
  const { auth, schedules } = useSelector((state : any) => ({
    auth: state.auth,
    schedules: state.schedules,
  }), shallowEqual);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [openEditDocument, setOpenEditDocument] = useState<any>(false);

  const [branch, setBranch] = useState<any>({});
  const [modality, setModality] = useState<any>('');
  const [field, setField] = useState<any>({});
  const [service, setService] = useState<any>({});
  const [day, setDay] = useState<any>({});
  const [hour, setHour] = useState<any>({});
  const [time, setTime] = useState<any>({});
  const [coupon, setCoupon] = useState<any>({});
  const [unit, setUnit] = useState<any>('');
  const [duration, setDuration] = useState<any>('');
  const [payment, setPayment] = useState<any>({});
  const [autoRenew, setAutoRenew] = useState<any>(true);
  const [id, setId] = useState<any>('');

  const checkoutTracked = useRef(false);
  const prevPaymentMethod = useRef<string | null>(null);

  const getEcommerceParams = useCallback(() => buildEcommerceParams({
    id: service.id,
    name: service.name,
    price: service.price ?? 0,
    quantity: unit > 0 ? unit : 1,
    itemBrand: branch?.attributes?.name,
    itemVariant: attributes?.item_variant,
    coupon: coupon?.id ? coupon : null,
    purchaseType: attributes?.type,
  }), [
    attributes?.item_variant,
    attributes?.type,
    branch?.attributes?.name,
    coupon,
    service.id,
    service.name,
    service.price,
    unit,
  ]);

  const trackPaymentSuccess = (transactionId: string) => {
    trackPurchase({
      ...getEcommerceParams(),
      transaction_id: String(transactionId),
      payment_type: payment.paymentMethod,
    });
  };

  const close = () => {
    setOpen(false);

    onClosed && onClosed();

    setBranch({});
    setModality('');
    setField({});
    setService({});
    setDay({});
    setHour({});
    setTime({});
    setCoupon({});
    setUnit({});
    setDuration('');
    setPayment({});
    setAutoRenew(true);
    setId('');
  }

  useEffect(() => {
    if (isOpen) {
      setOpen(true);

      attributes.branch && setBranch(attributes.branch);
      attributes.modality && setModality(attributes.modality);
      attributes.field && setField(attributes.field);
      attributes.service && setService(attributes.service);
      attributes.day && setDay(attributes.day);
      attributes.hour && setHour(attributes.hour);
      attributes.time && setTime(attributes.time);
      attributes.coupon && setCoupon(attributes.coupon);
      attributes.unit && setUnit(attributes.unit);
      attributes.duration && setDuration(attributes.duration);
      attributes.id && setId(attributes.id);

      setTimeout(() => {
        MenuComponent.reinitialization()
      }, 1000)
    } else {
      close();
    }
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) {
      checkoutTracked.current = false;
      prevPaymentMethod.current = null;
      return;
    }

    if (service?.id && !checkoutTracked.current) {
      checkoutTracked.current = true;
      const params = getEcommerceParams();
      trackAddToCart(params);
      trackBeginCheckout(params);
    }
  }, [isOpen, service?.id, getEcommerceParams]);

  useEffect(() => {
    if (!isOpen || !payment?.paymentMethod) {
      return;
    }

    if (payment.paymentMethod === prevPaymentMethod.current) {
      return;
    }

    prevPaymentMethod.current = payment.paymentMethod;

    trackAddPaymentInfo({
      ...getEcommerceParams(),
      payment_type: payment.paymentMethod,
    });
  }, [isOpen, payment?.paymentMethod, getEcommerceParams]);

  const confirmPayment = () => {
    let paymentMethod = payment.paymentMethod;
    let cardId = (payment.paymentMethod === 'credit_card' && payment.card && payment.card.id) || null;
    let creditId = (payment.paymentMethod === 'credit' && payment.creditId) || null;
    let metadata = {
      session_id: getSessionIdFromToken(auth.authToken),
    };

    dispatch<any>(getMeInfo()).then((data: any) => {
      if (data && data.attributes && data.attributes.document) {
        if (attributes?.type === 'schedule') {
          let start_at = day + ' ' + time.id;
          let finish_at = calculateMinutes(start_at, hour);

          dispatch<any>(createSchedule(field.id, service.id, start_at, finish_at, metadata, coupon.id, paymentMethod, cardId, creditId)).then((schedule: any) => {
            trackPaymentSuccess(schedule.id);
            navigate(`/compras/locacao-de-quadra/${schedule.id}`)
          });
        }

        if (attributes?.type === 'credit_purchase') {
          dispatch<any>(createCreditPurchase(service.id, unit, paymentMethod, metadata, cardId, coupon.id)).then((creditPurchase: any) => {
            trackPaymentSuccess(creditPurchase.id);
            navigate(`/compras/pacotes-de-creditos/${creditPurchase.id}`)
          });
        }

        if (attributes?.type === 'signature') {
          if (modality === 'invoice') {
            dispatch<any>(payOnlineInvoice(
              attributes.service.id,
              paymentMethod,
              metadata,
              cardId,
              autoRenew
            )).then((invoice: any) => {
              trackPaymentSuccess(invoice.id);
              onClosed();
            });
          }

          if (modality === 'single') {
            dispatch<any>(createSignature(
              branch?.attributes?.partner_id,
              service.id,
              paymentMethod,
              metadata,
              cardId,
              coupon.id,
              payment.paymentMethod === 'credit_card' && autoRenew
            )).then((signature: any) => {
              trackPaymentSuccess(signature.relationships.invoices[0].id);
              navigate(`/faturas/${signature.relationships.invoices[0].id}`)
            });
          }

          if (modality === 'update') {
            dispatch<any>(updateSignature(
              id,
              cardId,
            )).then((signature: any) => {
              trackPaymentSuccess(signature.id);
              onClosed();
            });
          }
        }

        if (attributes?.type === 'contract') {
          if (modality === 'invoice') {
            dispatch<any>(payOnlineInvoice(
              attributes.service.id,
              paymentMethod,
              metadata,
              cardId,
              autoRenew
            )).then((invoice: any) => {
              trackPaymentSuccess(invoice.id);
              onClosed();
            });
          }
        }
      } else {
        setOpenEditDocument(true);
      }
    }).catch(() => {
      // setOpenCreateCreditCard(true);
    });
  }

  const changeAutoRenew = (value) => {
    setAutoRenew(value);

    if (value) {
      setPayment({});
    }
  }

  const getPeriod = (value) => {
    if (value === 1) {
      return 'mês';
    }

    return `a cada ${value} meses`;
  }

  const parseValue = (value, type) => {
    let message = formatMoney(value);

    if (type === 'percentage') {
      message = value + '% na compra';
    }

    return message;
  }

  return (
    <>
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={true}
        show={open}
        onHide={() => close()}
        dialogClassName="custom-modal mw-700px"
        className="bg-black bg-opacity-50"
      >
        <form className="form form-label-right" autoComplete="off">
          <Modal.Header>
            <Modal.Title id="example-modal-sizes-title-lg" className="py-2 flex-root d-flex justify-content-center">
              <h2 className="fd-uppercase">Finalize sua compra</h2>
            </Modal.Title>

            <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => close()}>
              <span className="svg-icon svg-icon-1">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor" />
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor" />
                </svg>
              </span>
            </div>
          </Modal.Header>
          <Modal.Body>
            <form className="mx-auto mw-450px w-100 pt-0 pb-10" id="kt_modal_offer_a_deal_form">
              <div className="current" data-kt-stepper-element="content">
                <div className="w-100">
                  {time && day && time.id && <>
                    <div className="fv-row">
                      <label className="d-flex flex-stack mb-5">
                        <span className="d-flex align-items-center me-2">
                          <span className="d-flex flex-column">
                            <span className="text-gray-700 fw-bold fs-6">Data</span>
                          </span>
                        </span>
                        <span className="d-flex align-items-center me-2">
                          <span className="d-flex flex-column">
                            <span className="text-bold fw-bold fs-6">{formatLongDate(day) + ' • '+time.id}</span>
                          </span>
                        </span>
                      </label>
                    </div>
                    <div className="separator mx-0 my-5"></div>
                  </>}

                  {hour && hour.id && <>
                    <div className="fv-row">
                      <label className="d-flex flex-stack mb-5">
                        <span className="d-flex align-items-center me-2">
                          <span className="d-flex flex-column">
                            <span className="text-gray-700 fw-bold fs-6">Duração</span>
                          </span>
                        </span>
                        <span className="d-flex align-items-center me-2">
                          <span className="d-flex flex-column">
                            <span className="text-bold fw-bold fs-6">{hour.id + ' hrs'}</span>
                          </span>
                        </span>
                      </label>
                    </div>
                    <div className="separator mx-0 my-5"></div>
                  </>}

                  {service && service.name && <>
                    <div className="fv-row">
                      <label className="d-flex flex-stack mb-5">
                        <span className="d-flex align-items-center me-2">
                          <span className="d-flex flex-column">
                            <span className="text-gray-700 fw-bold fs-6">Serviço</span>
                          </span>
                        </span>
                        <span className="d-flex align-items-center me-2">
                          <span className="d-flex flex-column">
                            <span className="text-bold fw-bold fs-6">{service.name}</span>
                          </span>
                        </span>
                      </label>
                    </div>
                    <div className="separator mx-0 my-5"></div>
                  </>}

                  {duration && <>
                    <div className="fv-row">
                      <label className="d-flex flex-stack mb-5">
                        <span className="d-flex align-items-center me-2">
                          <span className="d-flex flex-column">
                            <span className="text-gray-700 fw-bold fs-6">Duração</span>
                          </span>
                        </span>
                        <span className="d-flex align-items-center me-2">
                          <span className="d-flex flex-column">
                            {!autoRenew && <span className="text-bold fw-bold fs-6">{duration > 1 ? `${duration} meses` : `1 mês`}</span>}
                            {autoRenew && <span className="text-bold fw-bold fs-6">{duration > 1 ? `A cada ${duration} meses` : `Mensal`}</span>}
                          </span>
                        </span>
                      </label>
                    </div>
                    <div className="separator mx-0 my-5"></div>
                  </>}

                  {field && field.attributes && field.attributes.name && <>
                    <div className="fv-row">
                      <label className="d-flex flex-stack mb-5">
                        <span className="d-flex align-items-center me-2">
                          <span className="d-flex flex-column">
                            <span className="text-gray-700 fw-bold fs-6">Local</span>
                          </span>
                        </span>
                        <span className="d-flex align-items-center me-2">
                          <span className="d-flex flex-column">
                            <span className="text-bold fw-bold fs-6">{field.attributes.name}</span>
                          </span>
                        </span>
                      </label>
                    </div>
                    <div className="separator mx-0 my-5"></div>
                  </>}

                  {attributes?.type === 'signature' && modality === 'single' && autoRenew && <>
                    <div className="fv-row">
                      <label className="d-flex flex-stack mb-5">
                        <span className="d-flex align-items-center me-2">
                          <span className="d-flex flex-column">
                            <span className="text-gray-700 fw-bold fs-6">Renovação automática</span>
                          </span>
                        </span>
                        <span className="d-flex align-items-center me-2">
                          <span className="d-flex flex-column">
                            {duration === 1 && <span className="text-bold fw-bold fs-6">Todo dia {format(new Date(), 'dd')}</span>}
                            {duration > 1 && <span className="text-bold fw-bold fs-6">{format(addMonths(new Date(), duration), 'dd/MM/yyyy')}</span>}
                          </span>
                        </span>
                      </label>
                    </div>
                    <div className="separator mx-0 my-5"></div>
                  </>}

                  {unit && unit > 0 && <>
                    <div className="fv-row">
                      <label className="d-flex flex-stack mb-5">
                        <span className="d-flex align-items-center me-2">
                          <span className="d-flex flex-column">
                            <span className="text-gray-700 fw-bold fs-6">Créditos</span>
                          </span>
                        </span>
                        <span className="d-flex align-items-center me-2">
                          <span className="d-flex flex-column">
                            <span className="text-bold fw-bold fs-6">{unit > 1 ? `${unit} créditos` :  `${unit} crédito`}</span>
                          </span>
                        </span>
                      </label>
                    </div>
                    <div className="separator mx-0 my-5"></div>
                  </>}

                  {time && time.id && <>
                    <div className="fv-row">
                      <span
                        className={`cursor-pointer text-primary`}
                        data-kt-menu='true'
                        data-kt-menu-trigger='click'
                        data-kt-menu-placement='bottom-end'
                        data-kt-menu-flip='bottom-end'
                      >
                        <h4 className={`text-white text-hover-primary text-end text-primary`}>
                          Regras de cancelamento
                        </h4>
                      </span>

                      <div className='menu menu-sub menu-sub-dropdown w-300px w-md-325px bg-light mt-5' data-kt-menu='true'>
                        <div className='px-10 py-4'>
                          <div className='fs-5 text-dark fw-bolder'>Regras de cancelamento</div>
                        </div>

                        <div className='separator border-1 border-gray-300'></div>

                        <div className='px-10 pt-3 pb-6' data-kt-user-table-filter='form'>
                          <div className='row d-flex'>
                            <div className="col-12 d-flex flex-wrap flex-column mt-2">
                              {time.attributes.can_cancel && <span className="fs-7 fd-uppercase text-gray-800">Você pode pedir o reembolso dessa compra via meio de pagamento até {formatLongDateTime(time.attributes.cancel_until, false)}</span>}
                              {!time.attributes.can_cancel && <span className="fs-7 fd-uppercase text-gray-800">• Essa compra não é reembolsável</span>}
                              <span className="fs-7 fd-uppercase text-gray-800">• Você também pode optar por receber um crédito com válidade de 30 dias para reagendar sua partida</span>
                              <span className="fs-7 fd-uppercase text-gray-800">• Se o campo cancelar sua reserva, você também recebe seu crédito de volta</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>}

                  {attributes.type === 'signature' && modality === 'single' && <>
                    <div className="mb-5">
                      <h2 className="mb-3 mt-10">Forma de renovação</h2>
                    </div>

                    <div className="fv-row mb-5" data-kt-buttons="true">
                      <div className="d-flex flex-stack mb-5">
                        {/* <div className="w-100 me-2">
                          <label
                            className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-5 mb-3 ${autoRenew === false && 'active'}`}
                            onClick={() => changeAutoRenew(false)}
                          >
                            <span className="d-flex flex-stack">
                              <span className="ms-4">
                                <span className="fs-5 fw-bold text-gray-900 mb-1 d-block">Avulso</span>
                                <span className="fw-semibold fs-6 text-gray-600">Compre apenas uma vez</span>
                              </span>
                            </span>
                          </label>
                        </div> */}
                        <div className="w-100 ms-2">
                          <label
                            className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-5 mb-3 ${autoRenew === true && 'active'}`}
                            onClick={() => changeAutoRenew(true)}
                          >
                            <span className="d-flex flex-stack">
                              <span className="ms-4">
                                <span className="fs-5 fw-bold text-gray-900 mb-1 d-block">Assinatura</span>
                                <span className="fw-semibold fs-6 text-gray-600">Quero uma assinatura</span>
                              </span>
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </>}

                  <div className="mb-5">
                    <h2 className="mb-3 mt-10">Pagamento</h2>
                  </div>

                  <div className="fv-row mb-5" data-kt-buttons="true">
                    <SelectPayment
                      branchId={branch?.attributes?.partner_id}
                      modality={modality}
                      paymentMethod={"create"}
                      serviceId={service && service.id}
                      type={attributes.type}
                      duration={hour && hour.minutes}
                      onSelect={(value: any) => setPayment(value)}
                      disableCredit={Boolean(attributes.type !== 'schedule' || coupon?.id)}
                      startAt={time?.id && day && `${day} ${time.id}`}
                      disableAll={service.price === 0}
                      disablePix={
                        (attributes.type === 'signature' && (modality === 'single' || modality === 'update') && autoRenew) ||
                        (attributes.type === 'contract' && modality === 'invoice')
                      }
                    />
                  </div>

                  <div className="separator mx-0 my-5"></div>

                  {attributes.type === 'contract' && modality === 'invoice' && payment.paymentMethod === 'credit_card' && <div className="form-check form-check-custom form-check-solid mb-5">
                    <input
                      className="form-check-input border-gray-500 border"
                      type="checkbox"
                      id="auto_renew"
                      checked={autoRenew}
                      onChange={() => setAutoRenew(!autoRenew)}
                    />
                    <label className="form-check-label text-white" htmlFor="auto_renew">
                      Utilizar esse cartão para cobranças futuras
                    </label>
                  </div>}

                  {coupon.id && <>
                    <div className="fv-row">
                      <label className="d-flex flex-stack mb-5">
                        <span className="d-flex align-items-center me-2">
                          <span className="d-flex flex-column">
                            <span className="text-muted fw-bold fs-6">Subtotal</span>
                          </span>
                        </span>
                        <span className="d-flex align-items-center me-2">
                          <span className="d-flex flex-column">
                            <span className="text-muted fw-bold fs-6">{formatMoney(service.price_total)}</span>
                          </span>
                        </span>
                      </label>
                    </div>
                    <div className="fv-row">
                      <label className="d-flex flex-stack mb-5">
                        <span className="d-flex align-items-center me-2">
                          <span className="d-flex flex-column">
                            <span className="text-muted fw-bold fs-6">Cupom de desconto</span>
                          </span>
                        </span>
                        <span className="d-flex align-items-center me-2">
                          <span className="d-flex flex-column">
                            <span className="text-white fw-bold fs-6">{parseValue(coupon.attributes.value, coupon.attributes.type)}</span>
                          </span>
                        </span>
                      </label>
                    </div>
                  </>}

                  {service && service.id && <div className="fv-row">
                    <label className="d-flex flex-stack mb-5">
                      <span className="d-flex align-items-center me-2">
                        <span className="d-flex flex-column">
                          <span className="fw-bold fs-4">Total</span>
                        </span>
                      </span>
                      <span className="d-flex align-items-center me-2">
                        <span className="d-flex">
                          {payment?.paymentMethod === 'credit' && <span className="text-primary fw-bold fs-3">
                            1 crédito
                          </span>}

                          {payment?.paymentMethod != 'credit' && <>
                            {service.price_total && service.price_total != service.price && <span className="text-gray-500 fs-8 mt-1 me-1 lineThrough">{formatMoney(service.price_total)}</span>}
                            {service.price === 0 && <span className="text-primary fw-bold fs-3">Grátis</span>}
                            {service.price != 0 && <span className="text-primary fw-bold fs-4">{formatMoney(service.price)} {attributes.type === 'signature' && modality === 'single' && autoRenew && ` / ${getPeriod(duration)}`} </span>}
                          </>}
                        </span>
                      </span>
                    </label>
                  </div>}

                  {attributes.type === 'schedule' && payment.paymentMethod === 'locally' && <div
                    className={`
                      card card-dashed flex-row flex-wrap p-5 my-5 w-100 border-warning border border-dashed`}
                  >
                    <div className="d-flex">
                      <i className="las la-exclamation-circle fs-2x text-warning me-3 mt-2"></i>
                      <span className="text-white">
                        Seu agendamento precisa ser aprovado pelo campo, vamos notificar quando for aprovado
                      </span>
                    </div>
                  </div>}

                  {attributes.type === 'schedule' &&
                  (payment.paymentMethod === 'credit_card' || payment.paymentMethod === 'pix') &&
                  time && time.attributes && !time.attributes.can_cancel && <>
                    <div
                      className={`
                        card card-dashed flex-row flex-wrap p-5 my-5 w-100 border-warning border border-dashed`}
                    >
                      <div className="d-flex">
                        <i className="las la-exclamation-circle fs-2x text-warning me-3 mt-4"></i>
                        <span className="text-white">
                          Compra não reembolsável<br />
                          Em caso de cancelamento você irá receber um crédito com vencimento de 30 dias
                        </span>
                      </div>
                    </div>
                  </>}

                  <div className="fv-row">
                    <div className="d-flex justify-content-center pt-7">
                      <button
                        type="button"
                        className="btn btn-lg fw-bold btn-primary w-100 w-md-50"
                        onClick={() => confirmPayment()}
                        disabled={schedules.actionsLoading || auth.actionLoading || !payment?.paymentMethod || payment?.paymentMethod === ''}
                      >
                        {(!schedules.actionsLoading && !auth.actionLoading) && <span className="indicator-label">PAGAR PELO APP</span>}
                        {(schedules.actionsLoading || auth.actionLoading) && <span className="indicator-label">
                          Carregando... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </Modal.Body>
        </form>
      </Modal>

      <EditDocument
        isOpen={openEditDocument}
        onClosed={() => setOpenEditDocument(false)}
      />
    </>
  )
}

export default PaymentPage;
